import { render, staticRenderFns } from "./ModalSuspendUser.vue?vue&type=template&id=78c5b97c"
import script from "./ModalSuspendUser.vue?vue&type=script&lang=js"
export * from "./ModalSuspendUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports